/* eslint-disable valid-jsdoc */
import BaseService from './base-service';
import {serialize} from '../helpers/request';
import axios from 'axios';

// Fora da classe de proposito: cada chamador cria a propria instancia de servico, entao guardar a
// requisicao em voo na instancia nao juntaria nada.
let buscaDaFrotaEmVoo = null;

export default class DeviceService extends BaseService {
    constructor() {
        super('devices');
    }

    static removeUnnecessaryFields = (data) => {
        const obj = Object.assign({}, data);

        delete obj.withTrace;
        delete obj.groupName;
        delete obj.positionBuffer;
        delete obj.currentPosition;
        delete obj.customerName;
        delete obj.customerCpfCnpj;
        delete obj.motionStreak;
        delete obj.motionState;
        delete obj.motionTime;
        delete obj.motionDistance;

        return obj;
    };

    static processCustomerAndGroupData = (responses) => {
        const device = responses[0];
        const groups = responses[1];

        let groupName = null;

        if (device.groupId) {
            const group = groups.find((g) => g.id === device.groupId);
            groupName = group && group.name ? group.name : null;
        }

        device.groupName = groupName;

        return device;
    };

    getDevices = async (data, query) => {
        const options = {
            method: 'get',
            url: 'devices',
        };

        if (data) {
            const {email, password} = data;
            options.auth = {username: email, password};
        }

        if (query) {
            options.url = `${options.url}?${serialize(Object.assign({_dc: new Date().getTime()}, query))}`;
        }

        // No arranque, a store da frota e a revalidacao da sessao pedem a lista inteira quase ao
        // mesmo tempo -- a segunda so precisa da quantidade, para decidir o perfil. Chamadas
        // simultaneas passam a dividir a mesma requisicao; assim que ela termina, a proxima busca
        // vai ao servidor normalmente.
        if (data || query) return this.request(options);

        if (!buscaDaFrotaEmVoo) {
            buscaDaFrotaEmVoo = this.request(options)
                .finally(() => {
                    buscaDaFrotaEmVoo = null;
                });
        }

        return buscaDaFrotaEmVoo;
    };

    /**
     * Method to process the list devices
     *
     * obs.: The method needs get information from the groups API
     *
     * @param [query]
     * @return {Promise<Device>}
     */
    list(query) {
        return new Promise((resolve, reject) => {
            const getDevices = this.__get(query ?
                `${this.url}?${serialize(Object.assign({_dc: new Date().getTime()}, query))}` : this.url);
            const getGroups = this.__get(`groups`);

            axios.all([getDevices, getGroups])
                .then(axios.spread((...responses) => {
                    const data = [];
                    const devices = responses[0];
                    const groups = responses[1];

                    devices.sort((a, b) => a.name.localeCompare(b.name));

                    devices.forEach((device) => {
                        let groupName = null;
                        if (device.groupId) {
                            const group = groups.find((g) => g.id === device.groupId);
                            groupName = group && group.name ? group.name : null;
                        }
                        data.push({groupName, ...device});
                    });

                    resolve(data);
                })).catch((errors) => reject(errors));
        });
    }

    save(data) {
        const device = DeviceService.removeUnnecessaryFields(data);

        return new Promise((resolve, reject) => {
            const saveDevice = super.save(device);
            const getGroups = this.__get(`groups`);

            axios.all([saveDevice, getGroups])
                .then(axios.spread((...responses) => {
                    resolve(DeviceService.processCustomerAndGroupData(responses));
                })).catch((errors) => reject(errors));
        });
    }


    update(data) {
        const device = DeviceService.removeUnnecessaryFields(data);

        return new Promise((resolve, reject) => {
            const updateDevice = super.update(device);
            const getGroups = this.__get(`groups`);

            axios.all([updateDevice, getGroups])
                .then(axios.spread((...responses) => {
                    resolve(DeviceService.processCustomerAndGroupData(responses));
                })).catch((errors) => reject(errors));
        });
    }

    accumulator( deviceId, totalDistance, hours ) {
        // Metros e milissegundos, como o servidor guarda; campo undefined nao vai no corpo e o servidor o mantem.
        return this.__put(`devices/${deviceId}/accumulators`, {deviceId, totalDistance, hours});
    }

    accumulatorHistory( deviceId ) {
        return this.__get(`devices/${deviceId}/accumulators/history`);
    }

    getDevicesByCustomerId = (customerId) => {
        return this.__get(`${this.url}?${serialize(Object.assign({_dc: new Date().getTime()}, {customerId}))}`);
    };

    findImages = (deviceId) => {
        return this.__get(`${this.url}/${deviceId}/images`);
    };

    uploadImages = (deviceId, images) => {
        const formData = new FormData();

        for (const image of images) {
            formData.append('files', image);
        }

        return this.__post(`${this.url}/${deviceId}/images`, formData);
    };

    removeImage = (deviceId, fileName) => {
        const params = {
            fileName,
        };

        return this.__delete(`${this.url}/${deviceId}/image?${serialize(params)}`, {
            data: {

            },
        });
    };

    getById = (id) => {
        return this.__get(`${this.url}/${id}`);
    };
}
